import { render, staticRenderFns } from "./MaterialDialog.vue?vue&type=template&id=731e0441&"
import script from "./MaterialDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports